import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrArrowRightIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M4.22162 1.21425C3.9261 1.49989 3.92613 1.96298 4.22168 2.24858L10.173 7.99964L4.22165 13.7514C3.92612 14.0371 3.92612 14.5002 4.22165 14.7858C4.51718 15.0714 4.99633 15.0714 5.29187 14.7858L11.7784 8.51678C11.9203 8.37961 12 8.19357 12 7.99959C12 7.8056 11.9203 7.61957 11.7783 7.48241L5.29183 1.21419C4.99628 0.92858 4.51713 0.928609 4.22162 1.21425Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrArrowRightIconComponent;
